/* Cloche de notifications : pastille rouge = notifications non lues (mémorisées dans ce navigateur) */
(function () {
  var roots = document.querySelectorAll('[data-tk-notif]');
  [].forEach.call(roots, init);
  function init(root) {
  var btn = root.querySelector('[data-tk-notif-btn]');
  var panel = root.querySelector('[data-tk-notif-panel]');
  var count = root.querySelector('[data-tk-notif-count]');
  if (!btn || !panel) return;
  var hasCount = !!count;
  var KEY = 'tk-notif-seen';
  var items = [].slice.call(panel.querySelectorAll('.tk-notif__item'));
  var ids = items.map(function (i) { return i.getAttribute('data-id'); });

  function seen() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function save(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* stockage indisponible : on ignore */ } }
  function refresh() {
    if (!hasCount) return;
    var s = seen();
    var unread = ids.filter(function (id) { return s.indexOf(id) === -1; }).length;
    count.textContent = unread;
    count.hidden = unread === 0;
    items.forEach(function (it) { it.classList.toggle('is-new', s.indexOf(it.getAttribute('data-id')) === -1); });
  }
  function open() { [].forEach.call(document.querySelectorAll('[data-tk-notif-panel]'), function (o) { if (o !== panel && !o.hidden) { o.hidden = true; } }); panel.hidden = false; btn.setAttribute('aria-expanded', 'true'); if (window.innerWidth < 1000) { panel.style.top = Math.round(btn.getBoundingClientRect().bottom + 10) + 'px'; } else { panel.style.top = ''; } if (hasCount) { save(ids); refresh(); } }
  function close() {
    if (panel.hidden) return;
    panel.hidden = true; btn.setAttribute('aria-expanded', 'false');
    if (hasCount) { save(ids); refresh(); }
  }
  btn.addEventListener('click', function (e) { e.stopPropagation(); if (panel.hidden) open(); else close(); });
  root.querySelector('[data-tk-notif-close]').addEventListener('click', close);
  document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  refresh();
  }
})();
